var AppPersonalInformationComponent = (function () {
    function AppPersonalInformationComponent() {
    }
    return AppPersonalInformationComponent;
}());
export { AppPersonalInformationComponent };



// WEBPACK FOOTER //
// /home/runner/work/debtpanel-portal/debtpanel-portal/webforms/legal-aid/src/app/personal-information/app-personal-information.component.ts.pre-build-optimizer.js